<template>
  <b-form-group :label="properties.label">
    <div class="border rounded border-color-light-gray">
      <div class="">
        <div class="d-flex w-100">
          <b-form-input
            size="sm"
            v-model="formText"
            no-resize
            :errors="formErrors.text"
            placeholder="Column name"
          />
          <b-form-select 
            size="sm"
            class="ml-1"
            style="width: 80px;"
            v-model="form.type" 
            :options="typeOptions" 
            :errors="formErrors.type"
            placeholder="Column type"
          />
          <b-button
            size="sm"
            variant="primary"
            class="text-white ml-1"
            style="width: 80px;"
            @click="addColumn"
          >
            Add
          </b-button>
        </div>
        
      </div>
      <div class="columns-list-container">
        <b-list-group v-if="value.length > 0" class="mt-1 p-1 forms-list">
          <draggable v-model="propertyValue">
            <b-list-group-item
              class="filter-value border pl-2 pr-2 pt-1 pb-1 mr-2 ml-1 mt-2"
              v-for="({ text, type }, index) in value"
              :key="index"
            >
              <div>
                <b-icon-grip-horizontal></b-icon-grip-horizontal>
                {{ text }} ({{ type ? type : "text" }})
              </div>
              <img
                class="filter-value-delete"
                :src="require('../../../assets/icons/close-circle.png')"
                @click="removeColumn(index)"
              />
            </b-list-group-item>
          </draggable>
        </b-list-group>
        <div v-else class="text-center color-custom-dark-grey m-1">
          No items selected.
        </div>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  name: "DatatableColumnsPropertyType",
  components: { Draggable },
  props: ["properties", "property", "value"],
  data() {
    return {
      form: {
        text: "",
        field: "",
        type: "text"
      },
      formErrors: {
        text: [],
        type: []
      },
      typeOptions: [
        {
          value: "text",
          text: "Text"
        },
        {
          value: "date",
          text: "Date"
        },
        {
          value: "time",
          text: "Time"
        }
      ]
    };
  },
  methods: {
    addColumn() {
      if (this.form.text.trim() && this.form.type) {
        const newColumns = [...this.value];
        newColumns.push({
          text: this.form.text,
          field: this.form.field,
          type: this.form.type
        });
        this.$emit("update-value", this.property, newColumns);
        this.form = { 
          text: "",
          field: "",
          type: "text" 
        };
      }
    },
    removeColumn(itemIndex) {
      const newValue = [...this.value];
      newValue.splice(itemIndex, 1);
      this.$emit("update-value", this.property, newValue);
    }
  },
  computed: {
    propertyValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("update-value", this.property, newValue);
      }
    },
    formText: {
      get() {
        return this.form.text;
      },
      set(newValue) {
        this.form.text = newValue
        this.form.field = newValue.replace(/\W/g, '')
      }
    }
  }
};
</script>

<style scoped>
.columns-list-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-value {
  position: relative;
  min-width: 50px;
  color: #a6a6a6;
  font-size: 14px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
</style>
